import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=5ca36a82&scoped=true"
import script from "@/views/Groups/Tabs/Profile.ts?vue&type=script&lang=ts&external"
export * from "@/views/Groups/Tabs/Profile.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Groups/Tabs/profile.scss?vue&type=style&index=0&id=5ca36a82&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca36a82",
  null
  
)

export default component.exports